import { useEffect } from "react";

function AdsterraAd({ adKey, width = 300, height = 250, format = "iframe", params = {} }) {
  useEffect(() => {
    // Configuración del anuncio
    window.atOptions = {
      key: adKey,
      format,
      height,
      width,
      params
    };

    // Crear el script dinámicamente
    const script = document.createElement("script");
    script.src = `https://www.highperformanceformat.com/${adKey}/invoke.js`;
    script.async = true;

    const container = document.getElementById(`ad-container-${adKey}`);
    if (container) {
      container.innerHTML = ""; // limpiar antes de insertar
      container.appendChild(script);
    }

    return () => {
      if (container) container.innerHTML = "";
    };
  }, [adKey, width, height, format, params]);

  return <div id={`ad-container-${adKey}`}></div>;
}

export default AdsterraAd;